export default "/images/vendor/flag-icons/flags/4x3/mw.svg?0159b1bd857af9ed65b8530687105890";